/**
 * Tiny pub/sub for the top navigation progress bar.
 * Used by lazy-route Suspense (chunk load) and optional callers.
 */

type Listener = (active: boolean) => void

const listeners = new Set<Listener>()
let activeCount = 0

export function startRouteProgress(): void {
  activeCount += 1
  if (activeCount === 1) {
    listeners.forEach((l) => l(true))
  }
}

export function stopRouteProgress(): void {
  activeCount = Math.max(0, activeCount - 1)
  if (activeCount === 0) {
    listeners.forEach((l) => l(false))
  }
}

export function subscribeRouteProgress(listener: Listener): () => void {
  listeners.add(listener)
  listener(activeCount > 0)
  return () => {
    listeners.delete(listener)
  }
}
